import type { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import type { Styled } from "~/utils";

export const Card = ({ className, children }: PropsWithChildren<Styled>) => {
  return (
    <div
      className={twMerge(
        "rounded-xl bg-surface-container-high p-4 hover:bg-surface-container-high/70 dark:bg-surface-container-default-dark dark:hover:bg-surface-container-default-dark/70",
        className,
      )}
    >
      {children}
    </div>
  );
};
